import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class LPClientInfoForm extends Vue {
    public title: string = 'LPClientInfoForm';

    @Prop({
        default: () => {
            return {
                name: '',
                phoneSuffix: '+1',
                phone: '',
                salutations: '',
                email: '',
            };
        }
    })
    public clientInfo: any;

    @Watch('clientInfo', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public clientInfoRules: any = {
        // name: [
        //     { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        // ],
    };
}
